import { render } from "./S91070.vue?vue&type=template&id=80245d3a"
const script = {}
script.render = render

export default script